import InventoryItem from "./InventoryItem";
import type { Items, QuantityData } from "../lib/api";

interface InventoryProps {
  items: Items;
  setQuantity: (key: string, quantity: QuantityData[]) => void;
}

export default function InventoryInput({ items, setQuantity }: InventoryProps) {
  return (
    <div>
      {items.items.map((item) => (
        <InventoryItem key={item.name} item={item} setQuantity={setQuantity} />
      ))}
    </div>
  );
}
